import type { RenderContext, VideoFrame } from '../../types';
import { BaseEffect } from '../base';
import { stableEffectSeed, withOverlay } from './composite';
import { buildEmberParticles, drawEmbers } from '../../particles/engine';

const DEFAULTS = { count: 500, brightness: 0.9, speed: 1 };

export class FireEmbersEffect extends BaseEffect {
  constructor(id: string, clip: Partial<import('../../types').EffectTimelineClip>) {
    super(id, 'fire_embers', clip, DEFAULTS);
  }

  protected renderGpu(frame: VideoFrame, params: Record<string, number>, context: RenderContext): VideoFrame {
    return this.renderCpu(frame, params, context);
  }

  protected renderCpu(frame: VideoFrame, params: Record<string, number>, context: RenderContext): VideoFrame {
    const seed = stableEffectSeed(context, this.id);
    const particles = buildEmberParticles(
      frame.width, frame.height, params.count, params.brightness, params.speed,
      context.frameIndex, seed,
    );
    return withOverlay(frame, (ctx) => drawEmbers(ctx, particles), 'lighter');
  }
}
